import { jsx } from "react/jsx-runtime";
import { Box } from "../../../Box/index.js";
import FillBanner_styles from "./FillBanner.styles.js";
const FillBanner = ({ children })=>{
    const { classes } = FillBanner_styles();
    return /*#__PURE__*/ jsx(Box, {
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        px: "16",
        py: {
            xs: '12',
            md: '16'
        },
        children: /*#__PURE__*/ jsx(Box, {
            className: classes.autoFillBanner,
            children: children
        })
    });
};
export default FillBanner;
